import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent} from './exercises/exercises.component'
import { TopicComponent } from './topic/topic.component';
import { TeacherGuard } from '../App/teacher-guard.service';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { TExamComponent } from './t-exam/t-exam.component';
import {TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { BinarySearchComponent } from './binary-search/binary-search.component';
import { TBinarySearchComponent } from './t-binary-search/t-binary-search.component';
import { BinaryInsertComponent } from './binary-insert/binary-insert.component';
import { TBinaryInsertComponent } from './t-binary-insert/t-binary-insert.component';
import { HashElementComponent } from './hash-element/hash-element.component';
import { THashElementComponent } from './t-hash-element/t-hash-element.component';
import { FindHashComponent } from './find-hash/find-hash.component';
import { TFindHashComponent } from './t-find-hash/t-find-hash.component';
import { TestHashComponent } from './test-hash/test-hash.component';
import { TTestHashComponent } from './t-test-hash/t-test-hash.component';
import { PlaygroundComponent } from './playground/playground.component';
import { ExampleComponent } from './example/example.component';
import { TExampleComponent } from './t-example/t-example.component';


const dataRepresentationRoutes: Routes = [
  { path: 'searchAndOrder', component:TopicComponent,
    children : [
      { path: '', component: ExercisesComponent, pathMatch: 'full'},
     
      { path: 'playground', component: PlaygroundComponent}, 
      { path: 'openQuestion/:id', component: OpenQuestionComponent}, 
      { path: 'multipleChoice/:id', component: MultipleChoiceComponent},
      { path: 'binarySearch/:id', component: BinarySearchComponent},
      { path: 'binaryInsert/:id', component: BinaryInsertComponent},
      { path: 'hashElement/:id', component: HashElementComponent},
      { path: 'findHash/:id', component: FindHashComponent},
      { path: 'testHash/:id', component: TestHashComponent},
      { path: 'example/:id', component: ExampleComponent},

      { path: 'exam/:id', component: ExamComponent},
      { path: 'exam/:examid/evaluation', component: EvaluationComponent},
      { path: 'exam/:examid/multipleChoice/:id', component: MultipleChoiceComponent},
      { path: 'exam/:examid/openQuestion/:id', component: OpenQuestionComponent}, 
      { path: 'exam/:examid/binarySearch/:id', component: BinarySearchComponent},
      { path: 'exam/:examid/binaryInsert/:id', component: BinaryInsertComponent},
      { path: 'exam/:examid/hashElement/:id', component: HashElementComponent},
      { path: 'exam/:examid/findHash/:id', component: FindHashComponent},
      { path: 'exam/:examid/testHash/:id', component: TestHashComponent},
      { path: 'exam/:examid/example/:id', component: ExampleComponent}

    ] },
    {path: 'teacher/searchAndOrder', canActivate: [TeacherGuard], canActivateChild:[TeacherGuard], component: TopicComponent,
      children:[
      { path: '', component: TExercisesComponent, pathMatch: 'full'},
      { path: 'openQuestion', component: TOpenQuestionComponent}, 
      { path: 'multipleChoice', component: TMultipleChoiceComponent},
      { path: 'openQuestion/:id', component: TOpenQuestionComponent}, 
      { path: 'multipleChoice/:id', component: TMultipleChoiceComponent},
      { path: 'binarySearch', component: TBinarySearchComponent},
      { path: 'binarySearch/:id', component: TBinarySearchComponent},
      { path: 'binaryInsert', component: TBinaryInsertComponent},
      { path: 'binaryInsert/:id', component: TBinaryInsertComponent},
      { path: 'hashElement', component: THashElementComponent},
      { path: 'hashElement/:id', component: THashElementComponent},
      { path: 'findHash', component: TFindHashComponent},
      { path: 'findHash/:id', component: TFindHashComponent},
      { path: 'testHash', component: TTestHashComponent},
      { path: 'testHash/:id', component: TTestHashComponent},
      { path: 'example', component: TExampleComponent},
      { path: 'example/:id', component: TExampleComponent},
      { path: 'allExercisesTeacher', component: TAllExercisesComponent},
      { path: 'allExamsTeacher', component: TAllExamsComponent},
      { path: 'exam', component: TExamComponent},
      { path: 'exam/:examid', component: TExamComponent, pathMatch: 'full'},
        { path: 'exam/:examid/allExercisesTeacher', component: TAllExercisesComponent},
        { path: 'exam/:examid/openQuestion', component: TOpenQuestionComponent},
        { path: 'exam/:examid/openQuestion/:id', component: TOpenQuestionComponent},
        { path: 'exam/:examid/multipleChoice', component: TMultipleChoiceComponent},
        { path: 'exam/:examid/multipleChoice/:id', component: TMultipleChoiceComponent},
        { path: 'exam/:examid/binarySearch', component: TBinarySearchComponent},
        { path: 'exam/:examid/binarySearch/:id', component: TBinarySearchComponent},
        { path: 'exam/:examid/binaryInsert', component: TBinaryInsertComponent},
        { path: 'exam/:examid/binaryInsert/:id', component: TBinaryInsertComponent},
        { path: 'exam/:examid/hashElement', component: THashElementComponent},
        { path: 'exam/:examid/hashElement/:id', component: THashElementComponent},
        { path: 'exam/:examid/findHash', component: TFindHashComponent},
        { path: 'exam/:examid/findHash/:id', component: TFindHashComponent},
        { path: 'exam/:examid/testHash', component: TTestHashComponent},
        { path: 'exam/:examid/testHash/:id', component: TTestHashComponent},
        { path: 'exam/:examid/example', component: TExampleComponent},
        { path: 'exam/:examid/example/:id', component: TExampleComponent}
    ] }
];

@NgModule({
  imports: [
      RouterModule.forChild(dataRepresentationRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})
export class TopicRoutingModule { }
